<!-- 私洽弹出框 -->
<template>
  <transition name="fade">
    <div v-show="visible" class="negotiate">
        <yd-popup v-model="negotiatePopup" position="center" width="84%" :close-on-masker="false" :masker-opacity="'0.6'">
          <div class="bg-white padding-sm padding-bottom-0 padding-top-md">
            <h2 class="fs18 text-center">{{type == null ? '私洽' : type == 0 ? '求购' : '出售'}}</h2>
            <div class="cl-box cl-box-bottom">
              <div class="cl-row">
                <div class="cl-td" style="padding-left: .2rem;padding-bottom: .36rem; padding-right: 0">
                  <img  :src="negotiateData.auctionGoodsIcon" style="width: 1rem;height: 1rem;">
                </div>
                <div class="cl-td" style="padding-left: .2rem;padding-bottom: .36rem; padding-right: 0;">
                  <p class="fw700 textfir" style="width: 4rem">{{negotiateData.auctionGoodsName}}</p>
                  <p class="fs12 margin-top-sm">预估价: <span class="red"><template v-if="negotiateData.referencePriceMax == 0 || negotiateData.referencePriceMax == null">暂无</template><template v-else>{{negotiateData.currencySymbol}}{{negotiateData.referencePriceMin | Bigprice}}-{{negotiateData.referencePriceMax | Bigprice}}</template></span></p>
                </div>
              </div>
            </div>

            <van-radio-group v-model="type" v-if="type == null" class="cl-box cl-box-bottom orangeRadio" >
              <div class="cl-row" @click="type = 0" >
                <div class="cl-td">
                  <p class="fw600" :class="{'forange':type == 0}">求购</p>
                </div>
                <div class="cl-td text-right">
                  <van-radio :name="0">&nbsp;</van-radio>
                </div>
              </div>
              <div class="cl-row" @click="type = 1">
                <div class="cl-td">
                  <p class="fw600" :class="{'forange':type == 1}">出售</p>
                </div>
                <div class="cl-td text-right">
                  <van-radio :name="1">&nbsp;</van-radio>
                </div>
              </div>
            </van-radio-group>
            <div v-else>
              <div class="cl-box cl-box-bottom">
                <div class="cl-row">
                  <div class="cl-td fw600" style="padding-right: 0;">意向价：</div>
                  <div class="cl-td" style="padding-left: 0;">
                    <div class="inputBox">
                    <input maxlength="8" style="border: none;" placeholder="请输入意向价格" @input="checkNo" class="price-intent" v-model="price"  />
                    </div>
                  </div>
                </div>
                <div class="cl-row">
                  <div class="cl-td">
                    <span class="fw600">数量：</span>
                  </div>
                  <div class="cl-td text-right spbox">
                    <van-stepper min="1" v-model="number" disable-input />
                  </div>
                </div>
              </div>
              <div style="padding-bottom: .6rem">
                <p class="padding-sm fs12 gray" style="margin-top: .1rem;">
                  <template v-if="type == 0">如有其他用户同意私洽，我们将电话联络您。中威网将按私洽成交价收取10%的佣金</template>
                  <template v-else>如有其他用户同意私洽，我们将电话联络您。中威网将按照拍卖手续费收取佣金</template>
                </p>
                <div class="padding-left-sm padding-right-sm">
                  <yd-button type="primary" @click.native="type = null" class="sky-btn grayf2 sky-btn-116-34 margin-top-md fw700">返回</yd-button>
                  <yd-button type="primary" v-if="submitLoading" class="sky-btn oranged sky-btn-116-34 margin-top-md fw700 pull-right">提交中</yd-button>
                  <yd-button type="primary" v-else @click.native="postNegotiate" class="sky-btn oranged sky-btn-116-34 margin-top-md fw700 pull-right">确定</yd-button>
                </div>
                <div class="check-box flex" v-if="type == 1">
                  <yd-checkbox :size="16" color="#F46309" v-model="checkbox">&nbsp;</yd-checkbox><span class="fs12">我已阅读并同意<span class="ablue" @click="goText('commissionAuctionContract')">《委托拍卖合同》</span><span class="ablue" @click="goText('sendInstructions')">《送拍声明书》</span></span>
                </div>
              </div>
            </div>
          </div>
          <i class="iconfont icon-chachatanchuang closeIcon fblack" @click="visible = false"></i>
        </yd-popup>
        <yd-popup v-model="textPopup" position="center" width="100%" height="100%" :close-on-masker="false" >
          <div class="textPopup-box">
            <commissionAuction v-if="textName === 'commissionAuctionContract'" :isShow.sync="textPopup"></commissionAuction>
            <sendInstructions  v-if="textName === 'sendInstructions'"  :isShow.sync="textPopup"></sendInstructions>
          </div>
        </yd-popup>
      </div>
  </transition>

</template>

<script>
import commissionAuction from '@/components/text/commissionAuctionContract'
import sendInstructions from '@/components/text/aboutSetting/direction/sendInstructions'
import Dialog from '@/utils/mixin/Dialog.js'
export default {
  components: {
    commissionAuction, sendInstructions
  },
  mixins: [Dialog],
  props: ['negotiateData'],
  name: 'NegotiateDialog',
  data () {
    return {
      type: null,
      number: 1,
      price: null,
      checkbox: true,
      textPopup: false,
      textName: '',
      submitLoading: false,
      negotiatePopup: true
    }
  },
  methods: {
  // 私洽
    async postNegotiate () {
      // 如果是出售，要判断是否已经实名认证过
      this.submitLoading = true
      if (this.type == 1) {
        if (!this.checkbox) {
          this.$dialog.toast({
            mes: '请阅读并同意《委托拍卖合同》《送拍声明书》', timeout: 1000
          })
          this.submitLoading = false
          return false
        }
        let _res = await this.api.queryCustomerInfo(Cookie.get('userSeq'))
        if (_res.data.certState === 0 || _res.data.certState === 3 || _res.data.certState === -1) {
          let mes = _res.data.certState === 0 ? '您尚未实名认证，请前往实名认证' : _res.data.certState === 3 ? '您的身份认证已过期，请重新认证' : '实名认证升级中，请重新上传认证资料'
          this.visible = false
          this.$layer.alert(mes, {title: '', btn: '去认证'}, () => {
            this.appMethod.goAprove(this)
          })
          this.submitLoading = false
          return false
        }
      }
      if (this.price == '' || this.price == '0' || this.price == null) {
        this.$dialog.toast({
          mes: '价格不能为空或者为0', timeout: 1000
        })
        this.submitLoading = false
        return false
      }
      let postData = {
        auctionGoodsSeq: this.negotiateData.auctionGoodsSeq,
        customerSeq: Cookie.get('userSeq'),
        number: this.number,
        price: this.price,
        type: this.type
      }
      this.api.insertAuctionGoodsNegotiate(postData)
        .then((res) => {
          if (res.state) {
            // 私洽成功后执行父组件的函数
            this.visible = false
            this.$emit('success', this.negotiateData.indexKey)
          }
          this.submitLoading = false
        })
    },

    goText (name) {
      if (this.$local.get('appOs') != '1') {
        this.textName = name
        this.textPopup = true
        // this.$router.push({name:name})
      } else {
        // this.$router.push({name:name})
        this.textName = name
        this.textPopup = true
      }
    },
    checkNo (value) {
      let data = value.data
      this.$nextTick(() => {
        let reg = /^(0|[1-9][0-9]{0,8})?$/
        if (data) {
          if (new RegExp(reg).test(data) === false) {
            this.price = value.target.value.replace(data, '')
          }
        }
      })
    }
  },
  mounted () {

  }

}
</script>

<style scoped lang="less">
.sky-btn.oranged{
  background: linear-gradient(90deg, #F58F0A 0%, #F46309 100%);
}
.orangeRadio {
  padding-bottom: .6rem;
}
.spbox /deep/ .yd-spinner input {
  background: #ffffff;
}
.check-box {
  padding: .24rem;
}
.check-box /deep/ .yd-checkbox{
  padding-right: 0;
  .yd-checkbox-icon{
    border-radius: 50%;
  }
}
  .textPopup-box {
    width: calc(100vw + 1px);
    height: 100vh;
    margin-left: -1px;
    left: -1px;
    background: #ffffff;
    overflow-y: auto;
  }
  .price-intent /deep/ input::-webkit-input-placeholder {
    font-size: .28rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/NegotiateDialog.vue